<template>
  <el-dialog :visible.sync="dialogFormVisible" :modal="false" :append-to-body="true" width="500px">
    <div slot="title">
      <span style="color:#e6a23b;font-size:16px">填写项目成员</span>
    </div>
    <el-form :model="project" size="mini">
      <el-form-item v-for="(field, k) in partnerFields" :key="k" :label="field" :prop="field">
        <div v-if="!project[field] || project[field].length == 0">
          <el-autocomplete
            v-model="inputValues[field]"
            size="small"
            @focus="currentInput = field"
            :fetch-suggestions="querySearchAccount"
            @select="handleSelectTag"
            placeholder="请选择"
          >
          </el-autocomplete>
        </div>
        <div class="flex items-center flex-wrap" v-else>
          <el-tag
            v-for="(tag, k) in project[field]"
            :key="k"
            effect="dark"
            closable
            @close="handleDelTag(field, tag)"
            class="mrb-5">
            {{tag}}
          </el-tag>
          <el-autocomplete
            v-if="currentInput==field"
            v-model="inputValues[field]"
            size="small"
            @focus="currentInput = field"
            :fetch-suggestions="querySearchAccount"
            @select="handleSelectTag"
            placeholder="请选择"
            class="w-150 mrb-5"
          >
          </el-autocomplete>
          <el-tag
            v-else
            effect="plain"
            @click="showTagInput(field)"
            class="mrb-5 cursor-pointer">
            +增加
          </el-tag>
        </div>
        <div class="lh-30" v-if="field == '项目成员' && businessLineMember.length > 0">
          <div class="font-12 text-gray-600">更多：以下顾问是同组成员，点击直接加入项目成员</div>
          <el-tag
            v-for="item in businessLineMember"
            :key="item"
            size="small"
            @click="selectMember(item, '项目成员')"
            class="mrb-5 cursor-pointer">
            {{ item }}
          </el-tag>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false" size="mini">跳过</el-button>
      <el-button type="primary" @click="save" size="mini">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogFormVisible: false,
      pid: '',
      project: {项目成员:[app.user.account]},
      accounts: app.accounts,
      partnerFields: ['项目对接', '项目经理', '项目成员'],
      businessLine: [],
      businessLineMember: [],
      inputValues: {
        项目对接: '',
        项目经理: '',
        项目成员: '',
      },
      currentInput: '',
    }
  },
  mounted() {
    this.getBusinessLine()
  },
  methods: {
    async open(pid) {
      if (!pid) return this.$message.error('没有pid')
      this.pid = pid
      this.project = {项目成员:[app.user.account]},
      this.dialogFormVisible = true
    },
    delMember(type, k) {
      this.project[type].splice(k, 1)
    },
    async getBusinessLine(){
      const res = await app.service('misc').getBusinessLine()
      // console.log(res)
      if(res.status==='success'){
        this.businessLine = res.data.filter(v=>v.depth==3&&v.members&&v.members.length>0)
      }else this.businessLine = []
    },
    showBusinessLineMember(account) {
      let businessLineMember = []
      this.businessLine.forEach(b=>{
        if (b.members.includes(account)) {
          businessLineMember = businessLineMember.concat(b.members)
        }
      })
      this.businessLineMember = Array.from(new Set(businessLineMember))
    },
    selectMember(account, field){
      if (!field) field = this.currentInput
      const accounts = this.project[field] || []
      const members = (Array.isArray(account))? account: [account]
      if (Array.isArray(account) && account.length>0) this.showBusinessLineMember(account[0])
      const val = []
      if (members.length > 0) {
        members.forEach(m=>{
          if (!accounts.includes(m)) {
            val.push(m)
          }
        })
      }
      this.currentInput = ''
      this.inputValues[field] = ''
      this.$set(this.project, field, accounts.concat(val))
    },
    querySearchAccount(queryString, cb) {
      if (!queryString) cb(this.accounts)
      const field = this.currentInput
      const arr = queryString ? this.accounts.filter(a=>a.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) : this.accounts
      const results = arr.map(item=>{
        return { value: item }
      })
      cb(results)
    },
    showTagInput(field) {
      if (!this.project.职能模块 && (field == '细分职能' || field == '擅长方向')) return this.$message('请先选择职能模块')
      this.currentInput = field
    },
    handleSelectTag(item) {
      const field = this.currentInput
      const value = item.realValue || item.value
      this.showBusinessLineMember(value)
      if (!this.project[field]) {
        this.$set(this.project, field, [value])
      } else if (!this.project[field].includes(value)) {
        this.$set(this.project, field, this.project[field].concat(value))
      }
      this.currentInput = ''
      this.inputValues[field] = ''
    },
    handleDelTag(field, tag) {
      const value = this.project[field].filter(dy => dy !== tag)
      this.$set(this.project, field, value)
    },
    async save() {
      if (!Object.values(this.project).find(f=>f && f.length > 0)) {
        return this.$message('请选择成员')
      }
      if (!this.pid) return this.$message.error('没有pid')
      await app.service('project').modify({
        id: this.pid,
        param: this.project,
      })
      this.$parent.addTmpMsg('项目成员添加成功')
      this.dialogFormVisible = false
    }
  }
}
</script>
<style src="../../../project/src/css/CreateProject20.css"></style>
